export const REACT_APP_SERVER_URL =
  process.env.REACT_APP_SERVER_URL || 'https://local.derp.website:8107';

// Hack to hide images that do not look good with a white background
export const HIDE_HEADER_IMG_SLUGS = ['cleveland--oh', 'lisbon-portugal'];

// Shared cookie name contract across CrowdRiff apps for the visitor's language choice.
export const LANGUAGE_COOKIE_NAME = 'cr_language';
